<template>
  <v-container fluid>
    <v-form ref="form">
      <RefSelector 
        required
        :loading="any_loading"
        :items="references.menu_classification_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="menu_classification"

        :label="$t('Классификация блюд')" 
        :hint="$t('На основе этой классификации будет формироваться список блюд, доступных для доставки')" 
      />
      
      <RefSelector 
        required
        :loading="any_loading"
        :items="references.station_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="station"

        :label="$t('Кассовая станция')" 
        :hint="$t('Автоматические кассовые операции будут совершаться от имени этой кассовой станции')" 
      />
      
      <RefSelector 
        required
        :loading="any_loading"
        :items="references.table_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="table"

        :label="$t('Стол')" 
        :hint="$t('Заказы доставки будут создаваться на этом столе')" 
      />
      
      <RefSelector 
        required
        :loading="any_loading"
        :items="references.employee_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="employee"

        :label="$t('Работник')" 
        :hint="$t('Автоматические кассовые операции будут выполняться от имени этого работника')" 
      />

      <RefSelector 
        required
        :loading="any_loading"
        :items="references.guest_types"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="guest_type"

        :label="$t('Типа гостя')" 
        :hint="$t('Указывается тип гостя, от которого будет создан заказ')" 
      />
      <TextField
        v-model="local_config.r_keeper_references.delayed_upload_time"
        :original_value="config.r_keeper_references.delayed_upload_time"
        :label="$t('Время выгрузки предзаказов')" 
        :hint="$t('В выбранное время будет происходит выгрузка предзаказов в систему')"
        type="time"
        :rule="[rules.required]"
        required
      />

      <TextField 
        v-model="local_config.r_keeper_references.guid_comment"
        :original_value="config.r_keeper_references.guid_comment"
        :label="$t('GUID длинного комментария')" 
        :hint="$t('Напишите GUID без скобок')"
      />
      
      <SelectField
        v-model="local_config.r_keeper_references.guest_discounts"
        :original_value="config.r_keeper_references.guest_discounts"
        :label="$t('Спец. скидки для гостей')" 
        :hint="$t('Список скидок доступных для гостя при оформлении заказа')"
        :items="references.order_discount_ref"
        multiple
      />

      <div class="d-flex align-center mt-1 mb-4">
        <v-divider />
          <span class="mx-4 text-grey text-body-2">Настройка категории для доставки</span>
        <v-divider />
      </div>
      
      <RefSelector 
        required
        :loading="any_loading"
        :items="references.order_category_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="delivery_order_category"

        :label="$t('Категория заказа для доставки')" 
        :hint="$t('С этой категорией будут создаваться заказы на доставку')" 
      />

      <RefSelector 
        :loading="any_loading"
        :items="references.categ_delivery_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="categ_dish_delivery"
        no_value_specified

        :label="$t('Классификация блюда для доставки')" 
        :hint="$t('На основе этой классификации блюдо доставки пропадет из основного меню')" 
      />
      <RefSelector 
        :loading="any_loading"
        :items="references.dish_delivery_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="dish_delivery"
        no_value_specified

        :label="$t('Блюдо для доставки')" 
        :hint="$t('Блюдо, которое будет отображаться в заказе, как наценка для доставки')" 
      />
      <TextField 
        v-model="local_config.r_keeper_references.minimal_sum"
        :original_value="config.r_keeper_references.minimal_sum"
        :label="$t('Минимальная сумма заказа для оформления доставки')" 
        :hint="$t('Для того, чтобы убрать минимальную сумму заказа, выставите значение в поле - 0')"
        type="number"
        :min="0"
        :rule="[rules.required, rules.noNegativeNumber]"
      />
      <RefSelector 
        :loading="any_loading"
        :items="references.order_discount_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="delivery_order_discount"
        no_value_specified

        :label="$t('Скидка/наценка для доставки')" 
        :hint="$t('С этой скидкой/наценкой будут создаваться заказы на доставку')" 
      />

      <div class="d-flex align-center mt-1 mb-4">
        <v-divider />
          <span class="mx-4 text-grey text-body-2">Настройка категории для самовывоза</span>
        <v-divider />
      </div>
      
      <RefSelector 
        required
        :loading="any_loading"
        :items="references.order_category_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="takeaway_order_category"

        :label="$t('Категория заказа для самовывоза')" 
        :hint="$t('С этой категорией будут создаваться заказы на самовывоз')" 
      />
      <RefSelector 
        :loading="any_loading"
        :items="references.order_discount_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="takeaway_order_discount"
        no_value_specified

        :label="$t('Скидка/наценка для самовывоза')" 
        :hint="$t('С этой скидкой/наценкой будут создаваться заказы на самовывоз')" 
      />
      <div class="d-flex align-center mt-1 mb-4">
        <v-divider />
          <span class="mx-4 text-grey text-body-2">Настройка категории для зала</span>
        <v-divider />
      </div>

      <RefSelector 
        required
        :loading="any_loading"
        :items="references.order_category_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="in_hall_order_category"

        :label="$t('Категория для заказа в зале')" 
        :hint="$t('С этой категорией будут создаваться заказы в зале')" 
      />
      <RefSelector 
        :loading="any_loading"
        :items="references.order_discount_ref"
        :config="config.r_keeper_references"
        v-model="local_config.r_keeper_references" 
        field_name="in_hall_order_discount"
        no_value_specified

        :label="$t('Скидка/наценка для заказов в зале')" 
        :hint="$t('С этой скидкой/наценкой будут создаваться заказы в зале')" 
      />

    </v-form>
  </v-container>
</template>

<script>
import settings_group_mixin from '../settings_group_mixin'
import rules_mixin from '@/components/common/rules_mixin.js'
import RefSelector from './RefSelector.vue'
import TextField from '../../common/TextField.vue'
import SelectField from '../../common/SelectField.vue';

export default {
  mixins: [settings_group_mixin, rules_mixin],
  data: () => ({
    local_loading: true,
    references: {}
  }),
  computed:{
    any_loading(){
      return this.local_loading || this.loading
    }
  },
  methods:{
    async loadReferences(){
      this.local_loading = true
      try {
        this.references = await this.$store.dispatch('apiQuery', {method: '/references'})
      } catch (e) {
        console.log(e)
      } finally {
        this.local_loading = false
      }
    },
    validate(){
      if (!this.$refs.form.validate()) {
        throw new Error(this.$t('Некоторые поля заполнены с ошибкой'))
      }
    }
  },
  async mounted(){
    await this.loadReferences()
  },
  components: {
    RefSelector,
    TextField,
    SelectField
  }
}
</script>